import { render } from "./ConsequencesBanner.vue?vue&type=template&id=898d3ca8"
import script from "./ConsequencesBanner.vue?vue&type=script&lang=js"
export * from "./ConsequencesBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__